import { AuditLogAuthor, AuditLogEntry } from 'apis/auditLogs';

import { automatedActivityTypes } from '../activityTypes.utils';

const anonymousUserId = 'aaaaaaaa-bbbb-4bbb-bbbb-41eb0c1b6fc9';

export const getLogEntryAuthorName = (entry: AuditLogEntry): string =>
  entry.author?.name ||
  entry.author?.email ||
  entry.author?.phone_number ||
  getNameFromUserId(entry.author?.id) ||
  '';

export const getLogEntryUserName = (user: AuditLogAuthor): string =>
  user?.name ||
  user?.email ||
  user?.phone_number ||
  getNameFromUserId(user?.id) ||
  '';

/** Whether the entry was authored by a user rather than by the system. */
export const hasLogEntryAuthor = (entry: AuditLogEntry): boolean =>
  Boolean(entry.author?.id) && entry.author.id !== anonymousUserId;

export const isAutomaticEvent = (entry: AuditLogEntry): boolean =>
  automatedActivityTypes.includes(entry.activity_type);

const getNameFromUserId = (userId?: string) =>
  userId === anonymousUserId ? '' : userId;
